import capitalize from "lodash/capitalize";
export var getUserFacingError = function getUserFacingError(error) {
  var _body$errors;
  if (!error.response || error.response.status === undefined || error.response.status >= 500) {
    return 'Unable to contact membership service. Try again later.';
  }
  var response = error.response,
    body = error.body;
  var _ref = (body === null || body === void 0 ? void 0 : (_body$errors = body.errors) === null || _body$errors === void 0 ? void 0 : _body$errors[0]) || {},
    detail = _ref.detail,
    field = _ref.field;
  if (response.status === 422) {
    return field ? "".concat(capitalize(field), " ").concat(detail) : detail;
  }
  return detail;
};
export var parseMemberResponseBody = function parseMemberResponseBody(body) {
  var member = body.members;
  var addresses = body.linked.addresses;
  return {
    member: member,
    addresses: addresses
  };
};
export var parseCreateSessionResponseBody = function parseCreateSessionResponseBody(body) {
  var member = body.linked.members[0];
  var addresses = []; // not included

  return {
    session: body.sessions,
    member: member,
    addresses: addresses
  };
};